import React, { Component, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  HashRouter,
} from "react-router-dom";
import Cookies from "js-cookie";
import axios from "./api";
import DashLayout from "./Layout";
import DashLayoutInvitee from "./LayoutInvitee";
import Login from "./scenes/Login/index";
import GuestLogin from "./scenes/Login/guest-login";
import ForgotPassword from "./scenes/Login/forgot-password";
import ResetPassword from "./scenes/Login/reset-password";
import PageNotFound from "./scenes/Register/404";
import RegisterEA from "./scenes/Register/register-ea_updated";
import RegisterEFS from "./scenes/Register/register-efs";
import RegisterLSP from "./scenes/Register/register-lsp";
import Signup from "./scenes/Signup/index";
import RegisterEASteps from "./scenes/Register/register-ea-steps";
import Billing from "./scenes/Register/billing";
import Dashboard from "./scenes/Dashboard/index";
import ReviewAdminStats from "./scenes/Dashboard/review-admin-stats";
import CallPage from "./scenes/CallPage/index";
import Search from "./scenes/CallPage/search";
import Wizard from "./scenes/Wizard/index_updated";
import WizardInvitee from "./scenes/WizardInvitee/index";
import EZCustomers from "./scenes/EZCustomers/new";
import QuoteForm from "./scenes/Quote/form";
import Quotes from "./scenes/Quote/index";
import ApproveMR from "./scenes/WizardInvitee/approve-mr";
import Onboarding from "./scenes/Onboarding/index";
import Financial from "./scenes/Financial/index";
import LandingPage from "./scenes/LandingPage/index_updated";
import LandingPageInvitee from "./scenes/LandingPage/invitee";
import Training from "./scenes/Training/index";
import TrainingPhilosophy from "./scenes/Training/philosophy";
import TrainingSpanish from "./scenes/Training/spanish";
import TrainingHoopinsure from "./scenes/Training/hoopinsure-u";
import CalendarInvites from "./scenes/CalendarInvites/index";
import Features from "./scenes/Features/index";
import ManageUsers from "./scenes/ManageUsers/index";
import EditUser from "./scenes/ManageUsers/edit";
import InviteLSP from "./scenes/ManageUsers/invite-lsp";
import InviteRS from "./scenes/ManageUsers/invite-rs";
import InviteVO from "./scenes/ManageUsers/invite-vo";
import InviteMortgageBroker from "./scenes/ManageUsers/invite-mb";
import LinkEFS from "./scenes/ManageUsers/link-efs";
import InvitedUsers from "./scenes/ManageUsers/invited-users";
import InactiveUsers from "./scenes/ManageUsers/inactive-users";
import Profile from "./scenes/Profile/index";
import AgencyProfile from "./scenes/Profile/agency";
import AgencyManagerProfile from "./scenes/Profile/agency_manager";
import Referrals from "./scenes/Referrals/index";
import AddReferrals from "./scenes/Referrals/add-referrals";
import EditReferral from "./scenes/Referrals/edit";
import ReferralPayouts from "./scenes/Referrals/referral-payouts";
import PaidReferrals from "./scenes/Referrals/paid-referrals";
import SendAGift from "./scenes/SendAGift/index";
import RewardProgram from "./scenes/RewardProgram/index";
import OrderHistory from "./scenes/RewardProgram/order-history";
import Gamification from "./scenes/Gamification/index";
import AddGame from "./scenes/Gamification/add";
import Videoform from "./scenes/Training/add";
import EditGame from "./scenes/Gamification/edit";
import GameReporting from "./scenes/Gamification/reporting";
import Winners from "./scenes/Gamification/winners";
import GameArchive from "./scenes/Gamification/archive";
import Reporting from "./scenes/Reporting/index";
import AdminActiveAgencies from "./scenes/SuperAdmin/active-agencies";
import SearchStaff from "./scenes/SuperAdmin/search-staff";
import DncCustomers from "./scenes/SuperAdmin/dnc-customers";
import AdminAgencyInfo from "./scenes/SuperAdmin/agency-info";
import AdminInactiveAgencies from "./scenes/SuperAdmin/inactive-agencies";
import Admin10in30Stats from "./scenes/SuperAdmin/10-in-30-stats";
import AdminStats from "./scenes/SuperAdmin/stats";
import AdminLastLogin from "./scenes/SuperAdmin/last-login";
import AdminOnboardAgencies from "./scenes/SuperAdmin/onboard-agencies";
import ActiveReviewSchedulers from "./scenes/SuperAdmin/rs-admin";
import DeactiveReviewSchedulers from "./scenes/SuperAdmin/rs-admin-deactivate";
import AdminVonAdmin from "./scenes/SuperAdmin/von-admin";
import AdminAgencyStats from "./scenes/SuperAdmin/agency-stats";
import AdminRSReporting from "./scenes/SuperAdmin/rs-reporting";
import AdminOnboardSentBFiles from "./scenes/SuperAdmin/onboard-sent-bfiles";
import AdminRegionStats from "./scenes/SuperAdmin/region-stats";
import AdminTangoAccounts from "./scenes/SuperAdmin/tango-accounts";
import AdminEmailContent from "./scenes/SuperAdmin/email-content";
import AdminRSUpload from "./scenes/SuperAdmin/edit-upload";
import AdminFeaturesAndFixes from "./scenes/SuperAdmin/features-fixes";
import AdminAddFeature from "./scenes/SuperAdmin/add-feature";
import AdminEditFeature from "./scenes/SuperAdmin/edit-feature";
import NewLead from "./scenes/NewLead/index";
import AM from "./scenes/Dashboard/am";
import Test from "./scenes/Dashboard/am";
import AgencyManagerNew from "./scenes/SuperAdmin/agencymanagernew";
import SearchDuplicateCustomers from "./scenes/SearchDuplicateCustomers";
import SearchCustomersToMergeWith from "./scenes/SearchCustomersToMergeWith";
import MergeCustomers from "./scenes/MergeCustomers";
import InviteAgencyManager from "./scenes/ManageUsers/invite-agency-manager";
import EditVideoForm from "./scenes/Training/editVideo";
import NotificationAdmin from "./scenes/Notification/add";
import Notification_BadPhone_Email from "./scenes/Notifications/notification_badphone_email";
import ScrollToTop from "./ScrollToTop";
import DuplicateFiles from "./scenes/DuplicateFiles";
import TrainingDetails from "./scenes/Training/trainingDetails";
import Step6 from "./scenes/WizardInvitee/parts/step6";
import PdfView from "./scenes/Wizard/pdfView";
import LockedUsers from "./scenes/ManageUsers/locked-users";
import { notification, message } from "antd";
import EaAppointmentLogs from "./scenes/Dashboard/parts/EA_And_LSP/EaAppointmentLogs";
import BfileHistory from "./scenes/Dashboard/parts/EA_And_LSP/BfileHistory";
import PrivacyPolicy from "./components/privacy-policy";
import TermsOfServices from "./components/terms-of-use";
import ExternalBFileThanks from "./scenes/Wizard/parts/ExternalBFileThanks";
import test from "./scenes/Wizard/parts/test";
import RSFSGrid from "./scenes/Dashboard/rsfs-grid";
import VonboardNEW from "./scenes/Dashboard/vonboard";
import REVIEWSCHEDULEROLD from "./scenes/Dashboard/reviewscheduler";
import VONBOARDEROLD from "./scenes/Dashboard/vonboard-back";
import Vonboard from "./scenes/Dashboard/vonboard";
import TestComp from "./scenes/Wizard/parts/test";
import TestComponent from "./scenes/Wizard/parts/test";
import EA from "./scenes/Dashboard/ea";
import LSP from "./scenes/Dashboard/lsp";
import RSFSAdminDashboard from "./scenes/Dashboard/rsfs-admin-dashboard";
import { REVIEW_ADMIN, REVIEWADMIN, REVIEWSCHEDULER, SUPER_ADMIN, VONBOARDER, VONSCHEDULER } from "./utils/Constants";
import REVIEWADMINOLD from "./scenes/Dashboard/reviewscheduler-admin";
import REVIEWADMINLAYOUT from "./scenes/Dashboard/parts/review-admin/ReviewAdminLayout";
import ManageSchedulers from "./scenes/ManageUsers/ManageSchedulers/ManageSchedulers";
import InvitedScheduler from "./scenes/ManageUsers/Invited Schedulers/InvitedScheduler";
import InActiveSchedulers from "./scenes/ManageUsers/InActive Schedulers/InActiveSchedulers";
import ActivatedSchedulers from "./scenes/ManageUsers/ActivatedSchedulers/ActivatedSchedulers";
import InviteScheduler from "./scenes/ManageUsers/Invite Scheduler/InviteScheduler";
import CallPageNew from "./scenes/CallPage/indexNew";
import EaDashboard from "./scenes/Dashboard/EaDashboards";
import AMDashboard from "./scenes/Dashboard/AMDashboard";
import GlobalDashboard from "./scenes/Dashboard/GlobalDashboard";
import { useBoundStore } from './store/useBoundStore';
import AgencyManagerListingAgGrid from "./scenes/SuperAdmin/AgencyManagerListingAgGrid";
import DetailsPage from "./scenes/Dashboard/shared-charts/DetailsPage";
import EmailTemplate from "./scenes/SuperAdmin/email_template";
import AddEmailTemplate from "./scenes/SuperAdmin/add_template";
import MonthlyDashboardReport from "./scenes/Dashboard/parts/review-admin/MonthlyDashboardReport";
import WeeklyDashboardStatList from "./scenes/Dashboard/parts/review-admin/WeeklyDashboardStatList";
import WeeklyDashboardBfileList from "./scenes/Dashboard/parts/review-admin/WeeklyDashboardBfileList";
import WeeklyMonthlyReport from "./scenes/Dashboard/parts/review-admin/WeeklyMonthlyReport";


const auth = {
  user: typeof Cookies.get("user_info") !== "undefined" ? JSON.parse(Cookies.get("user_info")) : {},
  isAuthenticated: typeof Cookies.get("is_logged_in") !== "undefined" ? true : false,
  authenticate(values, cb) {
    const queryString = values && values.captchaValue ? `?code=${values.captchaValue}` : "";
    const data = {
      email: values.email,
      password: values.password,
    };
    axios
      .post(`/api/v2/login${queryString}`, data)
      .then((res) => {
        let json = res.data;

        if (json.success) {
          this.isAuthenticated = true;
          Cookies.set("is_logged_in", "true",

            {
              secure: true,           //  HTTPS only
              sameSite: 'Lax',        // Add this — fixes the scan finding
              path: '/',              // explicit path
            }
          );
          if (json.password_expiry_approach) {
            // message.error(json.password_remaining_days_message, 0);
            notification.warning({
              message: json.password_remaining_days_message,
              duration: 0,
              style: {
                position: 'fixed',
                left: '50%',
                transform: 'translate(-50%, 0%)',
                width: 'fit-content',
                textAlign: 'center',
              }
            })
          }
          axios.get("/api/user").then((res) => {
            let user = res.data;
            useBoundStore.getState().setUserInfo(user)
            const roleNames = Array.isArray(res.data.roles) ? res.data.roles.map(role => role.rolename) : [];
            localStorage.setItem('roles', JSON.stringify(roleNames));
            this.user = user;
            if (user.user_type == VONSCHEDULER || user.user_type == REVIEWSCHEDULER) {
              useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: REVIEWSCHEDULER });
            } else if (user.user_type == VONBOARDER) {
              useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: VONBOARDER });
            } else if (user.user_type == REVIEWADMIN) {
              useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: REVIEWADMIN });
            }
            Cookies.set(
              "user_info",
              JSON.stringify({
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                id: user.id,
                user_type: user.user_type,
                jobs: user.jobs,
                default_date: user.default_date,
                last_login: user.last_login,
                language: user.language,
                active: user.active,
                agency_id: user.user_agency_assoc ? user.user_agency_assoc[0] ? user.user_agency_assoc[0].agency_id : null : null,
                dp_url: user.dp_url
              }), {
              secure: true,           //  HTTPS only
              sameSite: 'Lax',        // Add this — fixes the scan finding
              path: '/',              // explicit path
            }
            );
            cb({
              success: true,
              user,
            });
          });
        } else {
          if (json.password_expiry) {
            localStorage.setItem('password_expiry', json.errorMessage);
            window.open(json.password_reset_url, "_blank");
            // let basePath = json.password_reset_url.split('app/')[0]
            // let resetPath = json.password_reset_url.split('app/')[1]
            // newWindow.password_expiry = json.errorMessage;
            // const newWindow = window.open(json.password_reset_url + queryParams, "_blank");
          }
          cb({
            success: false,
            errorMessage: json.errorMessage,
          });
        }
      })
      .catch((error) => {
        cb({
          success: false,
          errorMessage: error.message,
        });
      });
  },
  getUser(cb) {
    axios.get("/api/user").then((res) => {
      this.user = res.data;
      if (typeof cb !== "undefined") {
        cb(this.user);
      }
    });
  },





  refresh(cb) {
    this.user = typeof Cookies.get("user_info") !== "undefined" ? JSON.parse(Cookies.get("user_info")) : {};
    this.isAuthenticated = typeof Cookies.get("is_logged_in") !== "undefined" ? true : false;
    if (typeof cb !== "undefined") {
      cb();
    }
  },




  signout(cb) {
    notification.destroy()
    this.isAuthenticated = false;
    Cookies.remove("is_logged_in");
    Cookies.remove("user_info");
    window.localStorage.clear();
    cb({
      success: true,
    });
  },
};











const auth1 = {
  isAuthenticated:
    typeof Cookies.get("is_logged_in_guest") !== "undefined" ? true : false,
  authenticate(values, cb) {
    axios
      .post("/api/bfile_login", {
        password: values.password,
        token: values.token,
      })
      .then((res) => {
        let json = res.data;
        if (json.success) {
          this.isAuthenticated = true;
          Cookies.set("is_logged_in_guest", "true", {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          });
          cb(json);
        } else {
          cb({
            success: false,
            errorMessage: json.errorMessage,
          });
        }
      })
      .catch((error) => {
        cb({
          success: false,
          errorMessage: error.message,
        });
      });
  },

  refresh(cb) {
    this.isAuthenticated =
      typeof Cookies.get("is_logged_in_guest") !== "undefined" ? true : false;
    if (typeof cb !== "undefined") {
      cb();
    }
  },
};

const PrivateRoute = ({ component: Component, menu: Menu, title = "", ...rest }) => (
  <Route
    strict
    exact
    {...rest}


    render={(props) => {
      auth.refresh();
      return auth.isAuthenticated === true ? (
        <DashLayout
          component={<Component {...props} auth={auth} user={auth.user} />}
          {...props}
          title={title}
          auth={auth}
          menu={Menu}
          user={auth.user}
          logout={auth.signout.bind(this)}
        />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

const PublicRoute = ({ component: Component, menu: Menu, isExternalBfile, ...rest }) => (
  <Route
    exact
    {...rest}
    render={(props) => {
      const { agency, lsp, wizardId } = props.match.params;


      const decryptedAgency = decrypt(agency);
      const decryptedLsp = decrypt(lsp);
      const decryptedWizardId = decrypt(wizardId);

      auth1.refresh();
      return auth1.isAuthenticated === true || typeof Cookies.get('is_logged_in') !== "undefined" ||
        props.location.pathname.indexOf("/approve-mr/") >= 0 ||
        props.location.pathname.indexOf("/create-bfile/") >= 0 ? (
        <DashLayoutInvitee
          component={<Component {...props} auth={auth1} />}
          {...props}
          auth={auth}
          menu={Menu}
          isExternalBfile={isExternalBfile}
          extAgencyId={decryptedAgency}
          extUserId={decryptedLsp}
          extWizardId={decryptedWizardId}
        />
      ) : (
        <Redirect
          to={{
            pathname: "/guest-login/" + props.match.params.token,
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

function SsoRedirect(props) {
  useEffect(() => {
    Cookies.set("is_logged_in", "true", {
      secure: true,           //  HTTPS only
      sameSite: 'Lax',        // Add this — fixes the scan finding
      path: '/',              // explicit path
    }

    );
    /*Cookies.set(
      "user_info",
      JSON.stringify({
        first_name: 'BFile',
        last_name: 'kag',
        email: 'bfileadmin@bfilesystem.com',
        id: 1,
        user_type: 'SUPER_ADMIN',
        jobs: null,
        default_date: 15,
        last_login: "2023-09-08T10:52:47",
        language: "en",
      })
    );
    props.history.push("/super-admin");
    */
    axios.get("/api/user").then((res) => {
      let user = res.data;
      Cookies.set(
        "user_info",
        JSON.stringify({
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          id: user.id,
          user_type: user.user_type,
          jobs: user.jobs,
          default_date: user.default_date,
          last_login: user.last_login,
          language: user.language,
          active: user.active,
          agency_id: user.user_agency_assoc ? user.user_agency_assoc[0] ? user.user_agency_assoc[0].agency_id : null : null,
          dp_url: user.dp_url
        }), {
        secure: true,           //  HTTPS only
        sameSite: 'Lax',        // Add this — fixes the scan finding
        path: '/',              // explicit path
      }
      );
      if (user.user_type === "SUPER_ADMIN") {
        props.history.push("/super-admin");
      } else {
        props.history.push("/dashboard");
      }
    });
  }, []);

  return <div>Loading ...</div>;
}


const decrypt = (encodedText) => {
  if (!isNaN(encodedText)) {
    return encodedText;
  }
  try {
    return atob(encodedText);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};



class Routes extends Component {



  render() {
    return (
      <HashRouter>
        <ScrollToTop>
          <Switch>
            <Route exact path="/404" component={PageNotFound} />
            <Route exact path="/test" component={TestComp} />
            <Route exact path="/privacy-policy/" component={PrivacyPolicy} />
            <Route exact path="/terms-of-service/" component={TermsOfServices} />
            <Route exact path="/" render={() => <Redirect to="/login" />} />

            {/* <Route path="*">
            <Redirect to="/404" />
          </Route> */}
            <Route
              exact
              path="/login"
              render={(props) => (
                <Login
                  login={auth.authenticate.bind(this)}
                  refresh={auth.refresh.bind(this)}
                  {...props}
                />
              )}
            />
            <Route
              exact
              path="/guest-login/:token"
              render={(props) => (
                <GuestLogin
                  login={auth1.authenticate.bind(this)}
                  refresh={auth1.refresh.bind(this)}
                  {...props}
                />
              )}
            />
            <Route
              exact
              path="/reset-password/:token"
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              exact
              path="/forgot-password"
              render={(props) => <ForgotPassword {...props} />}
            />
            <Route
              exact
              path="/signup"
              render={(props) => <Signup {...props} />}
            />
            <Route
              exact
              path="/register-lsp/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register-efs/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register-efs"
              render={(props) => <RegisterEFS {...props} />}
            />
            <Route
              exact
              path="/register-mb/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register-rs/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register-vo/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register/wizard"
              render={(props) => <RegisterEASteps {...props} />}
            />
            <Route
              exact
              path="/register/:token"
              render={(props) => <RegisterLSP {...props} />}
            />
            <Route
              exact
              path="/register"
              render={(props) => <RegisterEA {...props} />}
            />
            {/* <Route exact path="/404" component={PageNotFound} /> */}

            <Route
              exact
              path="/add-referrals/:token"
              render={(props) => <AddReferrals {...props} />}
            />
            <Route
              exact
              path="/billing/:token"
              render={(props) => <Billing {...props} />}
            />
            <Route
              exact
              path="/sso/appredirect"
              render={(props) => <SsoRedirect {...props} />}
            />
            <PrivateRoute
              path="/dashboard/rs-stats/:user_id(\d+)"
              component={ReviewAdminStats}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/agency_manager"
              component={AM}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/rs_admin"
              component={REVIEWADMINOLD}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/rsfs-grid"
              component={RSFSGrid}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/monthly-report/stat-list"
              component={WeeklyDashboardStatList}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/monthly-report/bfile-list"
              component={WeeklyDashboardBfileList}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/monthly-report"
              component={MonthlyDashboardReport}
              menu={["dashboard"]}
            />
             <PrivateRoute
              path="/dashboard/weekly-report"
              component={WeeklyMonthlyReport}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/vonboard"
              component={VONBOARDEROLD}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/vonboardnew"
              component={VonboardNEW}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/rs"
              component={REVIEWSCHEDULEROLD}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path='/dashboard/am'
              component={AMDashboard}
              menu={["dashboard"]} />

            <PrivateRoute
              path="/dashboard/test"
              component={Test}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/agency/:agency_id"
              component={Dashboard}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard/:action"
              component={Dashboard}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/dashboard"
              component={Dashboard}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/ea-old/dashboard"
              component={EA}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/lsp-old/dashboard"
              component={LSP}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/admin"
              component={REVIEWADMINLAYOUT}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/search/:search"
              component={Search}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/ea/:ea/:from/:to"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/ea/:ea"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/efs/:efs/:from/:to"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/efs/:efs"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/lsp/:lsp(\d+)/:from/:to"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/lsp/:lsp(\d+)"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/all/:from/:to"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter/:from/:to"
              component={CallPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles/:filter"
              component={CallPage}
              menu={["bfiles"]}
            />

            <PrivateRoute
              path="/newbfiles/:filter"
              component={CallPageNew}
              menu={["bfiles"]}
            />
            <PrivateRoute path="/bfilesOld" component={CallPage} menu={["bfiles"]} />


            <PrivateRoute path="/bfiles" component={CallPageNew} menu={["bfiles"]} />




            <PrivateRoute path="/bad-phone-numbers/:filters"
              component={CallPage}
              menu={["bfiles"]} />

            <PrivateRoute
              path="/wizard/step/:step/:bfile_id/:action"
              component={Wizard}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/wizard/step/:step/:bfile_id"
              component={Wizard}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/wizard/bfile"
              component={PdfView}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/wizard/step/:step"
              component={Wizard}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/wizard/new-ez-lynx-customer"
              component={EZCustomers}
              menu={["bfiles", "new-ez-lynx-customer"]}
            />
            <PrivateRoute
              path="/quotes/new"
              component={QuoteForm}
              menu={["bfiles", "new-quote"]}
            />
            <PrivateRoute
              path="/quotes/edit/:quote_id"
              component={QuoteForm}
              menu={["bfiles", "edit-quote"]}
            />
            <PrivateRoute
              path="/quotes"
              component={Quotes}
              menu={["bfiles", "quotes"]}
            />
            <PublicRoute
              path="/bfile/:token"
              component={LandingPageInvitee}
              menu={["bfiles", "create-bfile"]}
            />
            <PublicRoute
              path="/approve-mr/:token"
              component={ApproveMR}
              menu={[]}
            />
            <PublicRoute
              path="/edit-bfile/:token"
              component={WizardInvitee}
              menu={["bfiles", "create-bfile"]}
            />
            {/* External BFile */}
            <PublicRoute
              path="/create-bfile/:agency/:lsp/:wizardId?"
              component={Wizard}
              //  component={WizardInvitee}
              isExternalBfile={true}
              menu={["bfiles", "create-bfile"]}
            />
            <PublicRoute
              path="/create-bfile/:agency"
              component={WizardInvitee}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/wizard"
              component={Wizard}
              menu={["bfiles", "create-bfile"]}
            />
            <PrivateRoute
              path="/customer/:bfile_id/:action"
              component={LandingPage}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/appointment-history"
              component={EaAppointmentLogs}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/bfiles-history"
              component={BfileHistory}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/customer/:bfile_id"
              component={LandingPage}
              menu={["bfiles"]}
              title={"Customer Profile"}
            />
            <PrivateRoute
              path="/calendar-invites"
              component={CalendarInvites}
              menu={["calendar-invites"]}
            />
            <PrivateRoute
              path="/training/video"
              component={Videoform}
              menu={["training"]}
            />
            <PrivateRoute
              path="/training/details"
              component={TrainingDetails}
              menu={["training-video-list"]}
            />
            <PrivateRoute
              path="/training/video/:id"
              component={EditVideoForm}
              menu={["training"]}
            />
            {/** New Add */}
            <PrivateRoute
              path="/review-schedulers/active"
              component={ActiveReviewSchedulers}
              menu={["review-schedulers"]}
            />
            {/* new activated schedulers */}
            <PrivateRoute
              path="/review-schedulers/active-new"
              component={ActivatedSchedulers}
              menu={["review-schedulers"]}
            />
            <PrivateRoute
              path="/review-schedulers/deactive"
              component={DeactiveReviewSchedulers}
              menu={["review-schedulers"]}
            />
            <PrivateRoute
              path="/training/hoopinsure-u"
              component={TrainingHoopinsure}
              menu={["training"]}
            />
            <PrivateRoute
              path="/training/spanish/:category_id"
              component={TrainingSpanish}
              menu={["training"]}
            />
            <PrivateRoute
              path="/training/philosophy"
              component={TrainingPhilosophy}
              menu={["training"]}
            />
            <PrivateRoute
              path="/edit-video/:id"
              component={EditVideoForm}
              menu={["training"]}
            />
            <PrivateRoute
              path="/training"
              component={Training}
              menu={["training"]}
            />
            <PrivateRoute
              path="/video"
              component={Videoform}
              menu={["training"]}
            />
            {/*  */}
            {/* <PrivateRoute path="/training-copy" component={TrainingCopy} menu={["training"]} />
                    <PrivateRoute path="/training-copy/spanish" component={TrainingCopySpanish} menu={["training"]} /> */}
            <PrivateRoute
              path="/notification-admin"
              component={NotificationAdmin}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/ea-notification"
              component={Notification_BadPhone_Email}
              menu={["notifications"]}
            />
            <PrivateRoute
              path="/features"
              component={Features}
              menu={["features"]}
            />
            <PrivateRoute
              path="/profile/agency"
              component={AgencyProfile}
              menu={["agency-profile"]}
            />
            <PrivateRoute
              path="/profile"
              component={Profile}
              menu={["profile"]}
            />
            <PrivateRoute
              path="/profile/agency_manager"
              component={AgencyManagerProfile}
              menu={["profile"]}
            />
            <PrivateRoute
              path="/onboarding/step/:step/:bfile_id"
              component={Onboarding}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/financial/step/:step/:bfile_id/:action"
              component={Financial}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/financial/step/:step/:bfile_id"
              component={Financial}
              menu={["bfiles"]}
            />
            <PrivateRoute
              path="/manage-users/invite-lsp"
              component={InviteLSP}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/invite-agency-manager"
              component={InviteAgencyManager}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/invite-rs"
              component={InviteRS}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/invite-vo"
              component={InviteVO}
              menu={["manage-users"]}
            />
            {/* new Invite Scheduler component  instead of InviteVO and route  */}
            <PrivateRoute
              path="/manage-users/invite-vo-new"
              component={InviteScheduler}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/invite-mortgage-broker"
              component={InviteMortgageBroker}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/link-efs"
              component={LinkEFS}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/invited-users"
              component={InvitedUsers}
              menu={["manage-users"]}
            />
            {/* Invite Scheduler new component and route */}
            <PrivateRoute
              path="/manage-users/invited-users-new"
              component={InvitedScheduler}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/inactive-users"
              component={InactiveUsers}
              menu={["manage-users"]}
            />
            {/* Inactive users new component and route  inactive schedulers */}
            <PrivateRoute
              path="/manage-users/inactive-users-new"
              component={InActiveSchedulers}
              menu={["manage-users"]}
            />

            <PrivateRoute
              path="/manage-users/locked-users"
              component={LockedUsers}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users/edit-user/:user_id"
              component={EditUser}
              menu={["manage-users"]}
            />
            <PrivateRoute
              path="/manage-users"
              component={ManageUsers}
              menu={["manage-users"]}
            />
            {/* Manage users new path */}
            <PrivateRoute
              path="/manage-users-new"
              component={ManageSchedulers}
              menu={["manage-users"]}
            />
            {/** New Added Here ---------------- START ---------------- */}
            <PrivateRoute
              path="/search-duplicate-customers"
              component={SearchDuplicateCustomers}
              menu={["search-duplicate-customers"]}
            />
            <PrivateRoute
              path="/search-customers-to-merge-with"
              component={SearchCustomersToMergeWith}
              menu={["search-customers-to-merge-with"]}
            />
            <PrivateRoute
              path="/merge-customers"
              component={MergeCustomers}
              menu={["merge-customers"]}
            />
            {/** New Added Here ---------------- END ---------------- */}
            <PrivateRoute
              path="/referrals/edit/:referral_id"
              component={EditReferral}
              menu={["referrals"]}
            />
            <PrivateRoute
              path="/referrals/payouts"
              component={ReferralPayouts}
              menu={["referrals"]}
            />
            <PrivateRoute
              path="/referrals/paid"
              component={PaidReferrals}
              menu={["referrals"]}
            />
            <PrivateRoute
              path="/referrals"
              component={Referrals}
              menu={["referrals"]}
            />
            <PrivateRoute
              path="/reward-program/send-a-gift"
              component={SendAGift}
              menu={["reward-program"]}
            />
            <PrivateRoute
              path="/reward-program/order-history"
              component={OrderHistory}
              menu={["reward-program"]}
            />
            <PrivateRoute
              path="/reward-program"
              component={RewardProgram}
              menu={["reward-program"]}
            />
            <PrivateRoute
              path="/gamification/add"
              component={AddGame}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/video"
              component={Videoform}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/gamification/edit/:game_id"
              component={EditGame}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/gamification/view/:game_id"
              component={GameReporting}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/gamification/winners"
              component={Winners}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/gamification/archive"
              component={GameArchive}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/gamification"
              component={Gamification}
              menu={["gamification"]}
            />
            <PrivateRoute
              path="/reporting"
              component={Reporting}
              menu={["reporting"]}
            />
            <PrivateRoute
              path="/new-lead"
              component={NewLead}
              menu={["new-lead"]}
            />
            <PrivateRoute
              path="/super-admin/agency/:agency_id"
              component={AdminAgencyInfo}
              menu={["active-agencies"]}
            />
            <PrivateRoute
              path="/super-admin/inactive-agencies"
              component={AdminInactiveAgencies}
              menu={["inactive-agencies"]}
            />
            <PrivateRoute
              path="/super-admin/search-staff"
              component={SearchStaff}
              menu={["search-staff"]}
            />
            <PrivateRoute
              path="/super-admin/10-in-30-stats"
              component={Admin10in30Stats}
              menu={["10-in-30-stats"]}
            />
            <PrivateRoute
              path="/super-admin/agency-stats"
              component={AdminAgencyStats}
              menu={["agency-stats"]}
            />
            <PrivateRoute
              path="/super-admin/stats"
              component={AdminStats}
              menu={["stats"]}
            />
            <PrivateRoute
              path="/super-admin/last-login"
              component={AdminLastLogin}
              menu={["last-login"]}
            />
            <PrivateRoute
              path="/super-admin/onboard-agencies"
              component={AdminOnboardAgencies}
              menu={["onboard-agencies"]}
            />
            <PrivateRoute
              path="/super-admin/onboard-sent-bfiles"
              component={AdminOnboardSentBFiles}
              menu={["onboard-sent-bfiles"]}
            />
            <PrivateRoute
              path="/super-admin/region-stats"
              component={AdminRegionStats}
              menu={["region-stats"]}
            />
            <PrivateRoute
              path="/super-admin/duplicate-files"
              component={DuplicateFiles}
              menu={["duplicate-files"]}
            />
            <PrivateRoute
              path="/super-admin/edit-upload"
              component={AdminRSUpload}
              menu={["edit-upload"]}
            />
            {/* <PrivateRoute
            path="/super-admin/review-schedulers"
            component={ActiveReviewSchedulers}
            menu={["review-schedulers"]}
          /> */}
            <PrivateRoute
              path="/super-admin/virtual-follow-ups"
              component={AdminVonAdmin}
              menu={["virtual-follow-ups"]}
            />
            <PrivateRoute
              path="/super-admin/agency-manager"
              component={AgencyManagerNew}
              menu={["agency-manager"]}
            />
              <PrivateRoute
              path="/super-admin/global-dashboard"
              component={GlobalDashboard}
              menu={["global-dashboard"]}
            />

            <PrivateRoute
              path="/superAdmin/agencyManager/aggrids"
              component={AgencyManagerListingAgGrid}
              menu={["agency-manager"]}
            />
            <PrivateRoute
              path="/super-admin/rs-reporting"
              component={AdminRSReporting}
              menu={["review-schedulers"]}
            />
            <PrivateRoute
              path="/super-admin/tango-accounts"
              component={AdminTangoAccounts}
              menu={["tango-accounts"]}
            />
            <PrivateRoute
              path="/template/external-b-file-link"
              component={EmailTemplate}
              menu={["external-bFile-Link"]}
            />

            <PrivateRoute
              path="/template/email-template"
              component={EmailTemplate}
              menu={["email-template"]}
            />

            <PrivateRoute
              path="/super-admin/add-email-template"
              component={AddEmailTemplate}
              menu={["add-email-template"]}
            />
            <PrivateRoute
              path="/super-admin/email-content"
              component={AdminEmailContent}
              menu={["email-content"]}
            />
            <PrivateRoute
              path="/super-admin/features/add"
              component={AdminAddFeature}
              menu={["features"]}
            />
            <PrivateRoute
              path="/super-admin/features/edit/:post_id"
              component={AdminEditFeature}
              menu={["features"]}
            />
            <PrivateRoute
              path="/super-admin/features"
              component={AdminFeaturesAndFixes}
              menu={["features"]}
            />
            <PrivateRoute
              path="/super-admin"
              component={AdminActiveAgencies}
              menu={["active-agencies"]}
            />
            <PrivateRoute
              path="/dnc-customers"
              component={DncCustomers}
              menu={["dashboard"]}
            />
            <PrivateRoute
              path="/details"
              component={DetailsPage}
              menu={["dashboard"]}
            />
            <Route exact path="*" render={() => <Redirect to="/404" />} />
          </Switch>
        </ScrollToTop>
      </HashRouter>
    )
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js